<!--  -->
<template>
 <div class="declareDetail">
   <crumbs detail="true"/>
   <div class="container">
     <div class="detailmodel1 clearfix">
        <div class="leftcon fl">
          <h2 class="title">{{detailInfo.declareName}}</h2>
          <div class="content1">
              <img :src="getImage(detailInfo.image)" alt="">
              <div class="buttons">
                  <div class="goEnroll" @click="toApply">我要申报</div>
                  <div class="downFile" @click="downLoadUrl(detailInfo.attachment)">附件下载</div>
              </div>
          </div>
          <div class="dbttom">
              <div class="title"><span>项目详情</span><i></i></div>
              <div class="detailcontents" v-html="detailInfo.content"></div>
          </div>
        <comment v-if="detailInfo" @commentcount="commentCount" @coffsettop="cOffsettop" v-show="isCommentshow"></comment>
        <right-sidebar
          @pvcount="pvcount"
          :comment-count="commentTotal"
          :comment-gotop="commentOffsettop"
          :comment-show="isCommentshow"
          :title="detailInfo.declareName"
          :image="getImage(detailInfo.image)"
          :url="this.$route.fullPath"
          ref="rightSidebar"></right-sidebar>
        <go-top></go-top>

        </div>
        <div class="rightcon fr">
          <h2 class="title">申报记录
            <a href="javascript:;" @click="gotohistory">更多&gt;</a>
          </h2>
          <div class="shenRecord">
              <div class="record" @click.stop="openBox($event)" v-for="item in recordList" :key="item.id">
                    <div class="itemtxt">
                        <h2>{{item.projectName}}</h2>
                    </div>

                    <div class="hisdetail" style="display: none;">
                            <dl>
                                <dt>项目名称</dt><dd>{{item.projectName}}</dd>
                            </dl>
                            <dl>
                                <dt>属地</dt><dd>{{item.territorial}}</dd>
                            </dl>
                            <dl>
                                <dt>保护单位</dt><dd>{{item.protectionUnit}}</dd>
                            </dl>
                            <dl>
                                <dt>通讯地址</dt><dd>{{item.mailingAddress}}</dd>
                            </dl>
                            <dl>
                                <dt>电子邮箱</dt><dd>{{item.email}}</dd>
                            </dl>
                            <dl>
                                <dt>单位电话</dt><dd>{{item.workPhone}}</dd>
                            </dl>
                            <dl>
                                <dt>附件</dt><dd><a href="javascript:;" @click="downLoadUrl(item.attachment)">下载附件attachment</a></dd>
                            </dl>
                        </div>
              </div>
          </div>

           <h2 class="title">相关申报 <a href="javascript:;" @click="gotoList">更多&gt;</a></h2>

           <div class="delist">
             <div class="listLi" v-for="item in declList" :key="item.id" v-if="item.id !=id " @click="gotoDetail(item.id)">
                <img :src="getImage(item.image)" alt="">
                <p>{{item.declareName}}</p>
             </div>
           </div>
        </div>
    </div>
  </div>
 </div>
</template>

<script>
import Comment from '@/components/comment/index'
import RightSidebar from '@/components/rightsidebar/index'
import goTop from '@/components/gotop/index'
import {getDeclareDetail, getDeclareList, getRecordList} from '@/api/declare/index'
import crumbs from '@/components/crumbs/index'
export default {
  name: 'managementdeclarationDetail',
  meta: {
    showHeader: true
  },
  components: {
    crumbs,
    Comment,
    RightSidebar,
    goTop
  },
  data () {
    return {
      isCommentshow: true, // 是否显示评论
      pv: 0,
      commentTotal: '',
      commentOffsettop: '',
      menuId: '',
      id: '',
      detailInfo: {},
      params1: {
        menuId: '',
        page: 1,
        limit: 3,
        declareId: ''
      },
      params2: {
        page: 1,
        limit: 3,
        menuId: '',
        types: null,
        time: null,
        status: null,
        recommend: null
      },
      recordList: [],
      declList: []
    }
  },
  created () {
    this.id = this.$route.query.id
    this.menuId = this.$route.query.columnId
    this.params1.menuId = this.$route.query.columnId
    this.params1.declareId = this.$route.query.id
    this.params2.menuId = this.$route.query.columnId
    this.getDetail()
    this.getRecordList()
    this.getDeclareList()
  },
  methods: {
    /* 评论总数 */
    commentCount (val) {
      this.commentTotal = val
    },
    /* 评论距顶部距离 */
    cOffsettop (val) {
      this.commentOffsettop = val
    },
    pvcount (val) {
      this.pv = val
    },
    gotoList () {
      this.$router.push({
        path: '/managementdeclaration',
        query: {
          columnId: this.menuId
        }
      })
    },
    gotoDetail (id) {
      this.$router.push({
        path: '/managementdeclarationDetail',
        query: {
          id,
          columnId: this.menuId
        }
      })
    },
    getDeclareList () {
      getDeclareList(this.menuId, this.params2).then(res => {
        console.log(res, 'res2')
        this.declList = res.data.data
      })
    },
    getDetail () {
      getDeclareDetail(this.id).then(res => {
        console.log(res)
        this.detailInfo = res.data.data
      })
    },
    getRecordList () {
      getRecordList(this.menuId, this.params1).then(res => {
        console.log(res, 'record')
        this.recordList = res.data.data
      })
    },
    openBox (e) {
      let ele = e.currentTarget.getElementsByTagName('div')[1]
      if (ele.style.display === 'none') {
        ele.style.display = 'block'
      } else {
        ele.style.display = 'none'
      }
    },
    getImage (val) {
      if (val === undefined) {
        return require('@/assets/common/images/default.png')
      } else {
        return val
      }
    },
    toApply () {
      this.$router.push({
        path: '/toApply',
        query: {
          declareId: this.id,
          columnId: this.menuId,
          additionalContent: this.detailInfo.additionalContent
        }
      })
    },
    gotohistory () {
      this.$router.push({
        path: '/declerahistorydetail',
        query: {
          declareId: this.id,
          columnId: this.menuId
        }
      })
    },
    downLoadUrl (url) {
      if (url === undefined || url === '') {
        this.$message({
          message: '没有可下载附件',
          type: 'fail'
        })
      } else {
        window.open(url)
      }
    }
  },
  beforeDestroy () {

  }
}

</script>

<style lang='scss' scoped>
@import '../../assets/common/scss/declare.scss';
</style>



// WEBPACK FOOTER //
// src/view/managementdeclaration/detail.vue